module.exports = __webpack_public_path__ + "img/touXiang4.6f4dce63.png";